import React from 'react';
import { MdCheck } from 'react-icons/md';

// The status as a row of arrows (like Odoo's status bar, the same as the sales invoices): steps already
// passed (with a check), the current one highlighted and the next ones grey.
// - steps: [{ key, label }] in flow order.
// - current: key of the step reached.
// - exception: { label, tone: 'danger' | 'warning' | 'neutral' } for a status outside the flow (pending,
//   canceled, closed...): it is shown after the step reached, as the current one, and the later steps are hidden.
// - tail: { label, color } the same for a status with its own color (a status added in the settings).
// - dir: 'rtl' | 'ltr', so the arrows point along the reading direction.
const StatusFlow = ({ steps = [], current, exception, tail, ariaLabel, dir }) => {
    const reached = Math.max(0, steps.findIndex((step) => step.key === current));
    const closed = Boolean(exception || tail);
    const visible = closed ? steps.slice(0, reached + 1) : steps;
    const items = visible.map((step, index) => ({
        ...step,
        state: closed ? 'done' : index < reached ? 'done' : index === reached ? 'current' : 'next',
    }));
    if (exception) items.push({ key: 'exception', label: exception.label, state: `exception is-${exception.tone || 'danger'}`, current: !tail });
    if (tail) items.push({ key: 'tail', label: tail.label, color: tail.color, state: 'tail', current: true });

    return (
        <ol dir={dir} className='status-flow flex items-stretch m-0 p-0 list-none overflow-x-auto' aria-label={ariaLabel}>
            {items.map((item, index) => {
                const isCurrent = item.state === 'current' || Boolean(item.current);
                return (
                    <li
                        key={item.key}
                        style={item.color ? { '--flow-tail-bg': item.color } : undefined}
                        aria-current={isCurrent ? 'step' : undefined}
                        className={`status-flow-step ${index === 0 ? 'is-first' : ''} ${index === items.length - 1 ? 'is-last' : ''} is-${item.state}`}
                    >
                        {item.state === 'done' && <MdCheck size={13} className='shrink-0' aria-hidden='true' />}
                        <span className='whitespace-nowrap'>{item.label}</span>
                    </li>
                );
            })}
        </ol>
    );
};

export default StatusFlow;
